import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField';
import React, { FC } from 'react';
import useViewModel from './viewmodel';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    color: theme.palette.common.silver,
    '& > .MuiInputLabel-root': {
      color: theme.palette.common.silver,
    },
  },
}));

export interface GcpSearchBoxProps {
  label: string;
  handleSearch: (searchValue: string) => void;
  value: string;
  allowOnlyNumeric?: boolean;
}

const GcpSearchBox: FC<GcpSearchBoxProps> = (props) => {
  const classes = useStyles(props);
  const { label, handleSearch, value, allowOnlyNumeric } = props;
  const { searchValue, handleBlur, handleKeyDown, handleChange } = useViewModel(
    { handleSearch, value, allowOnlyNumeric }
  );

  return (
    <TextField
      className={classes.root}
      id="outlined-basic"
      label={label}
      size="small"
      type="search"
      value={searchValue}
      variant="outlined"
      onBlur={handleBlur}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
    />
  );
};

export default GcpSearchBox;
